export type User = {
  id: string;
  username: string;
  roles: { id: string; name: RoleName }[];
  createdAt: string;
  updatedAt: string;
};

export enum RoleName {
  "analyticsViewer" = "analyticsViewer", // views statistics
  "episodeManager" = "episodeManager", // manages episodes (can create and delete episodes)
  "imageEditor" = "imageEditor", // uploads manually edited images
  "userManager" = "userManager", // manages users and roles
  "visualsValidator" = "visualsValidator", // validates images and masks
  "promptEngineer" = "promptEngineer", // creates and manages prompts
}
